import { IconDefinition } from '@fortawesome/free-brands-svg-icons';
import { Observable } from 'rxjs';

export interface MenuItem {
  icon: IconDefinition | string[];
  label: string;
  onClick: () => void;
  // used like a key for PulseConfigurationKeys.UserMenuItemsBadges
  e2e: string;
  visible: Observable<boolean | undefined>;
  badge: Observable<BadgeMenuItem | undefined>;
}

export interface BadgeMenuItem {
  type: string;
  text: string;
}

export enum BadgeType {
  New = 'new',
}

export const badgeLabels: { [key in BadgeType]: string } = {
  [BadgeType.New]: $localize`:userMenu|New item badge text@@newItemBadgeText:New`,
};
